export const VERCEL_ENV_KEYS = ['development', 'preview', 'production'] as const;
